import React, { useEffect } from "react";
import {
  EthereumClient,
  w3mConnectors,
  w3mProvider,
} from "@web3modal/ethereum";
import { Web3Modal } from "@web3modal/html";
import {
  arbitrum,
  mainnet,
  polygon,
  polygonMumbai,
  sepolia,
  base,
} from "@wagmi/core/chains";
import {
  watchAccount,
  signMessage,
  disconnect,
  configureChains,
  createConfig,
} from "@wagmi/core";
import axios from "axios";
import {
  Container,
  Typography,
  Button,
  TextField,
  Grid,
  InputLabel,
  CircularProgress,
} from "@mui/material";
import { useState } from "react";
import OTPInput from "./OTPInput";
import "./App.css";
import swal from "sweetalert";
import AddTaskIcon from "@mui/icons-material/AddTask";
import {
  cryptoWaitReady,
  decodeAddress,
  signatureVerify,
} from "@polkadot/util-crypto";
import { u8aToHex } from "@polkadot/util";
import {
  web3Accounts,
  web3Enable,
  web3FromSource,
} from "@polkadot/extension-dapp";
import { stringToHex } from "@polkadot/util";

function DiscourseConnectSSOPage() {
  const [email, setEmail] = useState("");
  const [walletSignature, setWalletSignature] = useState("");
  const [walletAddress, setWalletAddress] = useState("");
  const [hideEmailField, setHideEmailField] = useState(false);
  const [disableVerifyButton, setDisableVerifyButton] = useState(false);
  const [emailVerified, setEmailVerified] = useState(false);
  const [OTPBox, setOTPBox] = useState(false);
  const [loadingLoader, setLoadingLoader] = useState(false);
  const handleChange = (event) => {
    setEmail(event.target.value);
  };
  const projectId = "5ffe7fb860784aa0e9cd478e728ab765";
  const chains = [arbitrum, mainnet, polygon, polygonMumbai, sepolia, base];
  // 2. Configure wagmi client
  const { publicClient } = configureChains(
    [mainnet, polygon, polygonMumbai],
    [w3mProvider({ projectId })]
  );
  const wagmiClient = createConfig({
    autoConnect: true,
    connectors: w3mConnectors({ projectId, chains }),
    publicClient,
  });
  // 3. Create ethereum and modal clients
  const ethereumClient = new EthereumClient(wagmiClient, chains);
  const web3Modal = new Web3Modal(
    {
      projectId,
    },
    ethereumClient
  );

  async function WalletConnect() {
    try {
      // localStorage.clear()
      await web3Modal.openModal();
    } catch (err) {
      await disconnect();
      // localStorage.clear()
    }
  }

  async function PolkadotConnect() {
    const extensions = await web3Enable("my dapp");
    const allAccounts = await web3Accounts();
    const account = allAccounts[0];
    const injector = await web3FromSource(account.meta.source);

    // this injector object has a signer and a signRaw method
    // to be able to sign raw bytes
    const signRaw = injector?.signer?.signRaw;

    if (!!signRaw) {
      // after making sure that signRaw is defined
      // we can use it to sign our message
      const { signature } = await signRaw({
        address: account.address,
        data: stringToHex("nonce"),
        type: "bytes",
      });
      const params = new Proxy(new URLSearchParams(window.location.search), {
        get: (searchParams, prop) => searchParams.get(prop),
      });

      const payload = params.sso;
      const sig = params.sig;
      const domain = params.domain;
      await axios
        .get(
          `${process.env.REACT_APP_BASE_URL}/validate-email-address?domain=${domain}&payload=${payload}&sig=${sig}&signature=${signature}&publicKey=${account.address}&wallet=Polkadot`,
          {
            headers: {
              "content-type": "application/json",
              token: localStorage.getItem("token"),
            },
          }
        )
        .then((res) => {
          if (res.data.status) {
            window.location.replace(
              `${domain}/session/sso_login?` + res.data.q
            );
          } else {
            setHideEmailField(true);
            setWalletSignature(signature);
            setWalletAddress(account.address);
          }
        })
        .catch((err) => {});
    }
  }
  const handleOTPComplete = async (otpValue) => {
    // Handle the completed OTP value here (e.g., send it to the server)
    setLoadingLoader(true);

    const params = new Proxy(new URLSearchParams(window.location.search), {
      get: (searchParams, prop) => searchParams.get(prop),
    });
    const domain = params.domain;
    await axios
      .get(
        `${process.env.REACT_APP_BASE_URL}/verify-discourse-verification-code?email=${email}&domain=${domain}&verificationCode=${otpValue}&signature=${walletSignature}&publicKey=${walletAddress}&wallet=Polkadot`,
        {
          headers: {
            "content-type": "application/json",
            token: localStorage.getItem("token"),
          },
        }
      )
      .then(async (res) => {
        swal({
          text: res.data.title,
          icon: "success",
        });
        setLoadingLoader(false);
        setOTPBox(false);
        setEmailVerified(true);
        const params = new Proxy(new URLSearchParams(window.location.search), {
          get: (searchParams, prop) => searchParams.get(prop),
        });

        const payload = params.sso;
        const sig = params.sig;
        const domain = params.domain;
        await axios
          .get(
            `${process.env.REACT_APP_BASE_URL}/validate-email-address?domain=${domain}&payload=${payload}&sig=${sig}&signature=${walletSignature}&publicKey=${walletAddress}&wallet=Polkadot`,
            {
              headers: {
                "content-type": "application/json",
                token: localStorage.getItem("token"),
              },
            }
          )
          .then((res) => {
            window.location.replace(
              `${domain}/session/sso_login?` + res.data.q
            );
          })
          .catch((err) => {});
      })
      .catch((err) => {
        swal({
          text: err.response.data.errorMessage,
          icon: "error",
        });
        setLoadingLoader(false);
      });
  };
  async function generateVerificationCode() {
    if (email.length >= 1 && !disableVerifyButton) {
      const params = new Proxy(new URLSearchParams(window.location.search), {
        get: (searchParams, prop) => searchParams.get(prop),
      });
      const domain = params.domain;
      await axios
        .get(
          `${process.env.REACT_APP_BASE_URL}/generate-discourse-verification-code?email=${email}&domain=${domain}`,
          {
            headers: {
              "content-type": "application/json",
              token: localStorage.getItem("token"),
            },
          }
        )
        .then(async (res) => {
          swal({
            text: res.data.title,
            icon: "success",
          });
          setOTPBox(true);
          setDisableVerifyButton(true);
        })
        .catch((err) => {
          swal({
            text: err.response.data.errorMessage,
            icon: "error",
          });
        });
    } else {
      swal({
        title: "Please enter the email",
        icon: "warning",
        button: "OK",
      });
    }
  }
  try {
    watchAccount(async function (account) {
      try {
        let signature;
        await new Promise((resolve) => setTimeout(resolve, 3000));
        if (account.address) {
          var address = account.address;
          signature = await signMessage({
            message: `nonce`,
          });
          await disconnect();
          const params = new Proxy(
            new URLSearchParams(window.location.search),
            {
              get: (searchParams, prop) => searchParams.get(prop),
            }
          );

          const payload = params.sso;
          const sig = params.sig;
          const domain = params.domain;
          await axios
            .get(
              `${process.env.REACT_APP_BASE_URL}/validate-email-address?domain=${domain}&payload=${payload}&sig=${sig}&signature=${signature}`,
              {
                headers: {
                  "content-type": "application/json",
                  token: localStorage.getItem("token"),
                },
              }
            )
            .then((res) => {
              if (res.data.status) {
                window.location.replace(
                  `${domain}/session/sso_login?` + res.data.q
                );
              } else {
                setHideEmailField(true);
                setWalletSignature(signature);
              }
            })
            .catch((err) => {});
        }
      } catch (err) {
        await disconnect();
      }
    });
  } catch (err) {}

  const [brandingDetails, setBrandingDetails] = useState({});

  async function getBrandingDetails() {
    const urlParams = new URLSearchParams(window.location.search.substring(1));
    const domain = urlParams.get("domain");

    await axios
      .get(
        `${process.env.REACT_APP_BASE_URL}/discourse/branding-page-info?domain=${domain}`,
        {}
      )
      .then((response) => {
        if (response.data.status) {
          setBrandingDetails(response.data.brandingDetails);
        } else {
          swal({
            title: "Something Went Wrong!",
            icon: "error",
            button: "OK",
          });
        }
      })
      .catch((error) => {
        swal({
          title: "Something Went Wrong!",
          icon: "error",
          button: "OK",
        });
      });
  }

  useEffect(() => {
    getBrandingDetails();
  }, []);

  return (
    <>
      {loadingLoader && (
        <div
          style={{
            opacity: "1 !important",
            zIndex: "2",
            textAlign: "center",
            position: "absolute",
            marginLeft: "49%",
            marginTop: "20%",
          }}
        >
          <CircularProgress />
        </div>
      )}
      <div
        className="bg"
        style={{
          backgroundImage: brandingDetails.customBackground
            ? `url(${brandingDetails.customBackground})`
            : null,
          height: "100%",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          backgroundSize: "cover",
          filter: loadingLoader ? "blur(4px)" : "none",
          transition: "filter 0.5s ease-in-out",
        }}
      >
        <Container
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            minHeight: "60vh",
            paddingTop: "10%",
          }}
        >
          <Typography
            fontSize={"3rem"}
            sx={{
              marginBottom: 3,
              marginTop: 3,
              color: brandingDetails.pageTitleTextColor,
            }}
          >
            {brandingDetails.pageTitle}
          </Typography>
          {!hideEmailField && (
            <Button
              variant="contained"
              onClick={PolkadotConnect}
              style={{
                backgroundColor: brandingDetails.connectWalletButtonColor,
                color: brandingDetails.connectWalletButtonTextColor,
              }}
            >
              {brandingDetails.connectWalletButtonText}
            </Button>
          )}
          {hideEmailField && (
            <Grid container justifyContent="center" spacing={1}>
              <Typography
                fontSize={"18px"}
                sx={{
                  color: brandingDetails.pageDescriptionTextColor,
                  marginBottom: 4,
                  textAlign: "center",
                  padding: "0 200px",
                }}
              >
                {brandingDetails.pageDescription}
              </Typography>
              <Grid item md={8} sm={8} xs={8}>
                <TextField
                  name="email"
                  label="Enter email"
                  variant="outlined"
                  size="small"
                  type="text"
                  sx={{ ml: 40, width: "55%" }}
                  required
                  value={email}
                  onChange={handleChange}
                  disabled={!disableVerifyButton ? false : true}
                />
              </Grid>
              <Grid item md={3} sm={3} xs={3}>
                <Button
                  variant="contained"
                  style={{
                    backgroundColor: brandingDetails.connectWalletButtonColor,
                    color: brandingDetails.connectWalletButtonTextColor,
                  }}
                  onClick={generateVerificationCode}
                >
                  {brandingDetails.connectWalletButtonText}
                </Button>
              </Grid>
              {emailVerified && (
                <Grid item md={1} sm={1} xs={1}>
                  <AddTaskIcon
                    style={{
                      color: "blue",
                      marginLeft: "-170px",
                      marginTop: "5px",
                    }}
                  />
                </Grid>
              )}
              {OTPBox && (
                <Grid item mt={6}>
                  <Grid item md={6} sm={6} xs={6} sx={{ margin: "auto" }}>
                    <Typography
                      variant="h6"
                      component="h2"
                      sx={{
                        textAlign: "center",
                        marginBottom: 2,
                        mt: 1,
                        color: brandingDetails.pageDescriptionTextColor,
                      }}
                    >
                      Enter Verification Code
                    </Typography>
                    <OTPInput onComplete={handleOTPComplete} />
                  </Grid>
                </Grid>
              )}
            </Grid>
          )}
        </Container>
      </div>
    </>
  );
}

export default DiscourseConnectSSOPage;
